import { withBemMod } from '@bem-react/core';

import { cnTextinput } from '../Textinput.cn';

import './Textinput_view_contrast.css';

export type WithViewContrastProps = {
    view?: 'contrast';
};

export const withViewContrast = withBemMod<WithViewContrastProps>(cnTextinput(), {});
